import { RecordBase } from '../../providers/request/record-base.model';
import { ProjectItemType } from './project-item-type.enum';
export class ProjectSectionItem extends RecordBase {
  projectId?: number;
  sectionId?: number;
  parentId?: number;
  type?: ProjectItemType;
  code?: string;
  fullCode?: string;
  projectTypeCode?: string;
  projectTypeName?: string;
  dwMileage?: string;
  highwayLevel?: string;
  mark?: string;
  constructionOrgName?: string;
  mileage?: string;
  name?: string;
  alias?: string;
  comment?: string;
  sortOrder?: number;
  level?: number;
  child?: Array<ProjectSectionItem>;
  inRecycleBin?: boolean;
  includeBeamYard?: boolean;
  isLJ?: boolean;
  //
  hasTf?: boolean;
}
